import axiosInstance from '../axiosInstance';

const getRankingLookup = async () => {
  return axiosInstance.get('/ranking/lookup').then((response) => {
    return response.data;
  });
};

const exportRankingPositions = async (eventId, data) => {
  return axiosInstance.post(`/ranking/event/${eventId}/export`, data).then((response) => {
    return response.data;
  });
};

/**
 * The positions that may be imported, for one category. Scoped separately from
 * the rest of the lookup because it is the one resource that takes a parameter.
 */
const getRankingPositions = async (category) => {
  return axiosInstance
    .get('/ranking/lookup/positions', { params: category ? { category } : {} })
    .then((response) => {
      return response.data;
    });
};

/**
 * Which sections are knockout rounds, and what each round's winner and loser
 * are placed as. Saved to the event, so it is classified once rather than at
 * every export.
 */
const saveRankingMapping = async (eventId, sectionMapping) => {
  return axiosInstance
    .put(`/ranking/event/${eventId}/mapping`, { sectionMapping })
    .then((response) => {
      return response.data;
    });
};

const rankingService = {
  getRankingLookup,
  getRankingPositions,
  exportRankingPositions,
  saveRankingMapping
};

export default rankingService;
